import * as React from 'react';

import { IModule } from '@sitegen/common/types';
import { IPlatform, IPlatformBannerProps, IPlatformBannerState } from './platform-banner.types';

import './platform-banner.styles.less';

class PlatformBanner extends React.Component<IPlatformBannerProps, IPlatformBannerState> {
    constructor(props: IPlatformBannerProps) {
        super(props);
        this.state = {
            platforms: [],
        };
        this.setupPlatforms();
    }

    public getPlatformIcon = (iconName: string): Promise<string> =>
        import(`./assets/${iconName.toLowerCase()}.png`)
            .then((pngModule: IModule): string => pngModule.default);

    public setupPlatforms = async () => {
        const { platformList } = this.props;

        const platformIcons: Promise<IPlatform>[] = platformList.map(type => (
            this.getPlatformIcon(type).then((iconURL: string) => ({ type, iconURL }))
        ));

        await Promise.all<IPlatform>(platformIcons).then(fulfilledPlatforms => {
            this.setState(prevState => ({
                ...prevState,
                platforms: fulfilledPlatforms
            }));
        });
    };

    public render() {
        const { platforms } = this.state;
        return (
            <div className="sitegen-platform-banner-logo-box">
                {platforms.map(platform => (
                    <img key={platform.type} src={platform.iconURL} alt={platform.type} />
                ))}
            </div>
        );
    }
}

export default PlatformBanner;
